import { Component, ReactNode } from 'react'

interface Props {
  children: ReactNode
}

interface State {
  hasError: boolean
  error: Error | null
}

/**
 * Filet de sécurité pour empêcher la page blanche complète quand une exception
 * non-attrapée survient pendant le rendu React (notamment sur mobile où certaines
 * APIs récentes lèvent des erreurs sur d'anciens Safari iOS / WebViews).
 */
export default class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, error: null }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error }
  }

  componentDidCatch(error: Error, info: unknown) {
    console.error('[ErrorBoundary] caught error', error, info)
  }

  handleReload = () => {
    try {
      window.location.reload()
    } catch {
      /* ignore */
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px', backgroundColor: '#fff', fontFamily: 'system-ui, -apple-system, sans-serif' }}>
          <div style={{ maxWidth: '420px', textAlign: 'center' }}>
            <h1 style={{ fontSize: '24px', fontWeight: 800, color: '#111827', marginBottom: '12px' }}>
              Une erreur s&apos;est produite
            </h1>
            <p style={{ fontSize: '15px', color: '#4b5563', marginBottom: '20px', lineHeight: 1.5 }}>
              L&apos;affichage de cette page a rencontré un problème. Vous pouvez réessayer en rechargeant la page.
            </p>
            <button
              type="button"
              onClick={this.handleReload}
              style={{ backgroundColor: '#dc2626', color: '#fff', padding: '12px 24px', borderRadius: '12px', fontWeight: 700, fontSize: '14px', border: 'none', cursor: 'pointer' }}
            >
              Recharger la page
            </button>
            <a
              href="/"
              style={{ display: 'inline-block', marginTop: '12px', color: '#6b7280', fontSize: '13px', textDecoration: 'underline' }}
            >
              Retour à l&apos;accueil
            </a>
          </div>
        </div>
      )
    }
    return this.props.children
  }
}
